export enum Type {
Employee,
Party,
}
